import { partnersData } from '@/mocks/home';

export default function PartnersSection() {
  return (
    <section className="py-14 md:py-18 bg-background-50">
      <div className="site-container px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 bg-secondary-50 text-secondary-700 text-xs font-semibold rounded-full mb-3">
            合作伙伴
          </span>
          <h2 className="text-2xl font-bold font-heading text-foreground-900">值得信赖的合作伙伴</h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {partnersData.map((partner, index) => (
            <div
              key={index}
              className="flex items-center justify-center gap-3 px-4 py-5 rounded-xl bg-background-100 border border-background-200 hover:border-accent-200 transition-all duration-300"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-50 text-accent-500">
                <i className={`${partner.icon} text-lg`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">{partner.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}